<template>
  <v-form ref="form" lazy-validation class="pl-12 pr-12">
    <v-layout row wrap>
      <v-flex md12>
        <div class="mb-12 title font-weight-regular">Detalhes do Hospital</div>
      </v-flex>
      <v-flex md4>
        <div class="subtitle-1 font-weight-regular blue--text text--darken-4">
          Nome
        </div>
      </v-flex>
      <v-flex md8>
        <v-text-field
          outlined
          clearable
          placeholder="Nome do Hospital"
          v-model="name"
          :rules="nameRules"
          dense
          type="text"
          color="teal accent-3"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <div class="subtitle-1 font-weight-regular blue--text text--darken-4">
          Localização
        </div>
      </v-flex>
      <v-flex md8>
        <v-text-field
          outlined
          clearable
          placeholder="Localização"
          v-model="location"
          :rules="locationRules"
          dense
          type="text"
          color="teal accent-3"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <div class="subtitle-1 font-weight-regular blue--text text--darken-4">
          Categoria
        </div>
      </v-flex>
      <v-flex md8>
        <v-select
          outlined
          clearable
          placeholder="Categoria"
          :items="categories"
          v-model="category"
          :rules="categoryRules"
          dense
          type="text"
          color="teal accent-3"
        ></v-select>
      </v-flex>
      <v-flex md4>
        <div class="subtitle-1 font-weight-regular blue--text text--darken-4">
          Serviços
        </div>
      </v-flex>
      <v-flex md8>
        <!-- <v-text-field
          outlined
          clearable
          placeholder="Serviços"
          v-model="services"
          :rules="servicesRules"
          dense
          type="text"
          color="teal accent-3"
        ></v-text-field> -->
        <v-row row wrap>
          <v-col class="pa-0 ma-0" cols="6">
            <v-checkbox
              v-model="servicesForCheck[1]"
              label="Ressonância Magnética"
            >
            </v-checkbox>
          </v-col>

          <v-col class="pa-0 ma-0" cols="6">
            <v-checkbox v-model="servicesForCheck[2]" label="Rádio X">
            </v-checkbox>
          </v-col>

          <v-col class="pa-0 ma-0" cols="6">
            <v-checkbox
              v-model="servicesForCheck[3]"
              label="Tomografia computadorizado"
            >
            </v-checkbox>
          </v-col>

          <v-col class="pa-0 ma-0" cols="6">
            <v-checkbox v-model="servicesForCheck[4]" label="Laboratório">
            </v-checkbox>
          </v-col>

          <v-col class="pa-0 ma-0" cols="6">
            <v-checkbox v-model="servicesForCheck[5]" label="UTI"> </v-checkbox>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <v-layout class="mt-2" row wrap></v-layout>
  </v-form>
</template>

<script>
export default {
  name: "HospitalInfo",
  props: ["hospital"],
  data: () => ({
    rmi: false,
    raioX: false,
    tomografy: false,
    lab: false,
    uti: false,
    location: undefined,
    name: undefined,
    category: undefined,
    categories: ["HPS", "SPA", "UTI"],
    nameRules: [(v) => !!v || "Nome precisa ser preenchido!"],
    servicesRules: [(v) => !!v || "Serviços precisa ser preenchido!"],
    categoryRules: [(v) => !!v || "Categoria precisa ser preenchido!"],
    locationRules: [(v) => !!v || "Localização precisa ser preenchido!"],
    services: [],
    servicesForCheck: [false, false, false, false, false, false],
  }),
  created() {
    if (this.hospital) {
      this.name = this.hospital.name;

      if (this.hospital.services) {
        this.hospital.services.forEach((element) => {
          let name = "";

          if (element.name) {
            name = element.name;
          } else if (typeof element == "string") {
            name = element;
          }

          if (name != "") {
            this.servicesForCheck[this.getIdbyService(name)] = true;
          }
        });
      }
      this.location =
        this.hospital.address.street +
        "," +
        this.hospital.address["number"] +
        "," +
        (this.hospital.neighborhood?this.hospital.neighborhood:'');
      this.category = this.hospital.category;
    }
  },
  computed: {
    selectedHospitalInfo() {
      let selected = this.$store.getters.selectedHospital;
      if (!selected) {
        return {};
      }
      return selected;
    },
  },
  methods: {
    getIdbyService(nameService) {
      switch (nameService) {
        case "Ressonância Magnética":
          return 1;
        case "Rádio X":
          return 2;
        case "Tomografia computadorizado":
          return 3;
        case "Laboratório":
          return 4;
        case "UTI":
          return 5;
        default:
          return 1;
      }
    },

    setHospitalInfo() {
      if (this.$refs.form.validate()) {
        let services = [];
        this.servicesForCheck.forEach((value, index, array) => {
          if (value) {
            services.push(index);
          }
        });
        return {
          name: this.name,
          address: this.location,
          category: this.category,
          services: services,
        };
      }
      return false;
    },
  },
};
</script>

<style>
</style>